import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'

const contains = (a, b) => {
  return String(a).toLowerCase().indexOf(String(b).toLowerCase()) >= 0
}

export const Search = ({
  reset,
  selectedBlock,
  searchValue,
  list,
  placeholder,
  onSearchChange,
  onSelectItem,
}) => {
  const filtered = list.filter(i => {
    return contains(i.name, searchValue) || contains(i.slug, searchValue)
  })

  return (
    <div>
      <div className={styles.inputBlock}>
        <input
          placeholder={placeholder}
          value={searchValue}
          onChange={onSearchChange}
          ref={r => r && r.focus()}
        />
        {reset && (
          <button className={styles.reset} onClick={reset}>
            Reset
          </button>
        )}
      </div>
      {selectedBlock}
      <div className={styles.suggestions}>
        {filtered.length > 0 ? (
          filtered.slice(0, 100).map(item => {
            return (
              <div
                className={styles.item}
                key={item.address}
                onClick={() => {
                  onSelectItem && onSelectItem(item)
                }}
              >
                <Image
                  src={`/site-api/thumbnails?url=${encodeURIComponent(
                    item.imgUrl
                  )}&size=30`}
                  width='30'
                  height='30'
                  alt={name}
                />
                <div className={styles.title}>{item.name}</div>
              </div>
            )
          })
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
